import { render, staticRenderFns } from "./Global_search.vue?vue&type=template&id=02e489b3&scoped=true"
import script from "./Global_search.vue?vue&type=script&lang=js"
export * from "./Global_search.vue?vue&type=script&lang=js"
import style0 from "./Global_search.vue?vue&type=style&index=0&id=02e489b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e489b3",
  null
  
)

export default component.exports